import { eventOccurrence, eventSeries, event_0 } from './getEventTypeString.locstring.json';
import loc from 'owa-localize';

import CalendarItem from 'owa-service/lib/contract/CalendarItem';

export default function getEventTypeString(item: CalendarItem): string {
    if (item.RecurrenceId != undefined) {
        return loc(eventOccurrence);
    }

    if (item.Recurrence != undefined) {
        return loc(eventSeries);
    }

    return loc(event_0);
}
